// The refusals Supabase gives when a password is written, in pt-BR.
//
// Two screens write passwords — `NewPasswordView` (arriving from a recovery
// e-mail) and `AccountPanel` (signed in, changing it deliberately) — and they
// hit the same refusals from the same endpoint. Keeping the table here is what
// stops them from drifting into saying different things about the same answer,
// the way the sales page and the checkout once quoted two different prices.
//
// Only the universal refusals live here. Anything whose right wording depends
// on how the visitor got to the field — an expired recovery link is not an
// expired session — stays with the screen that owns that context.

/** Same floor the signup field enforces, so no screen can promise a shorter one. */
export const MIN_LENGTH = 6;

/**
 * Translates a refusal that means the same thing on every screen.
 *
 * Returns `null` when the message is not one of them, so the caller can add its
 * own context-specific cases and then fall through to the original text.
 * Falling through verbatim is deliberate: an unrecognised message shown in
 * English is worse than nothing, but flattening it into "erro inesperado" hides
 * the one clue anybody had.
 */
export function translatePasswordRefusal(message: string): string | null {
  if (/different from the old password/i.test(message)) {
    return 'A nova senha precisa ser diferente da anterior.';
  }
  if (/at least \d+ characters|password.*too short/i.test(message)) {
    return `A senha precisa ter pelo menos ${MIN_LENGTH} caracteres.`;
  }
  return null;
}
